var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-md-right d-none d-md-block"},[_vm._v("Hand-crafted & Made with "),_c('feather-icon',{staticClass:"text-danger stroke-current",attrs:{"icon":"HeartIcon","size":"21"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }